/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const RptOpportunityDtoStatoOpportunityEnum = {
    ClosedLost: 'CLOSED_LOST',
    Discovery: 'DISCOVERY',
    MilestonePlanning: 'MILESTONE_PLANNING',
    NegotiationReview: 'NEGOTIATION_REVIEW',
    ProposalPriceQuote: 'PROPOSAL_PRICE_QUOTE',
    Prospecting: 'PROSPECTING',
    Qualification: 'QUALIFICATION'
};
/**
 * Check if a given object implements the RptOpportunityDto interface.
 */
export function instanceOfRptOpportunityDto(value) {
    return true;
}
export function RptOpportunityDtoFromJSON(json) {
    return RptOpportunityDtoFromJSONTyped(json, false);
}
export function RptOpportunityDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pkOpportunity': json['pkOpportunity'] == null ? undefined : json['pkOpportunity'],
        'fkAzienda': json['fkAzienda'] == null ? undefined : json['fkAzienda'],
        'denominazioneAzienda': json['denominazioneAzienda'] == null ? undefined : json['denominazioneAzienda'],
        'denominazioneCliente': json['denominazioneCliente'] == null ? undefined : json['denominazioneCliente'],
        'fkCliente': json['fkCliente'] == null ? undefined : json['fkCliente'],
        'fkQuote': json['fkQuote'] == null ? undefined : json['fkQuote'],
        'denominazioneOpportunity': json['denominazioneOpportunity'] == null ? undefined : json['denominazioneOpportunity'],
        'dataPotenzialeAvvio': json['dataPotenzialeAvvio'] == null ? undefined : (new Date(json['dataPotenzialeAvvio'])),
        'oppImportoAnno': json['oppImportoAnno'] == null ? undefined : json['oppImportoAnno'],
        'statoOpportunity': json['statoOpportunity'] == null ? undefined : json['statoOpportunity'],
        'oppImporto': json['oppImporto'] == null ? undefined : json['oppImporto'],
        'dataUltimaModifica': json['dataUltimaModifica'] == null ? undefined : (new Date(json['dataUltimaModifica'])),
        'oppPercProb': json['oppPercProb'] == null ? undefined : json['oppPercProb'],
        'rischio': json['rischio'] == null ? undefined : json['rischio'],
        'fkStrutturaBusiness': json['fkStrutturaBusiness'] == null ? undefined : json['fkStrutturaBusiness'],
        'quoteCosti': json['quoteCosti'] == null ? undefined : json['quoteCosti'],
        'quoteGG': json['quoteGG'] == null ? undefined : json['quoteGG'],
        'quoteMargine': json['quoteMargine'] == null ? undefined : json['quoteMargine'],
        'dataCreazione': json['dataCreazione'] == null ? undefined : (new Date(json['dataCreazione'])),
        'oppMOL': json['oppMOL'] == null ? undefined : json['oppMOL'],
        'oppNumAttivitaInAgenda': json['oppNumAttivitaInAgenda'] == null ? undefined : json['oppNumAttivitaInAgenda'],
        'linkOppSF': json['linkOppSF'] == null ? undefined : json['linkOppSF'],
    };
}
export function RptOpportunityDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'pkOpportunity': value['pkOpportunity'],
        'fkAzienda': value['fkAzienda'],
        'denominazioneAzienda': value['denominazioneAzienda'],
        'denominazioneCliente': value['denominazioneCliente'],
        'fkCliente': value['fkCliente'],
        'fkQuote': value['fkQuote'],
        'denominazioneOpportunity': value['denominazioneOpportunity'],
        'dataPotenzialeAvvio': value['dataPotenzialeAvvio'] == null ? undefined : ((value['dataPotenzialeAvvio']).toISOString().substring(0, 10)),
        'oppImportoAnno': value['oppImportoAnno'],
        'statoOpportunity': value['statoOpportunity'],
        'oppImporto': value['oppImporto'],
        'dataUltimaModifica': value['dataUltimaModifica'] == null ? undefined : ((value['dataUltimaModifica']).toISOString()),
        'oppPercProb': value['oppPercProb'],
        'rischio': value['rischio'],
        'fkStrutturaBusiness': value['fkStrutturaBusiness'],
        'quoteCosti': value['quoteCosti'],
        'quoteGG': value['quoteGG'],
        'quoteMargine': value['quoteMargine'],
        'dataCreazione': value['dataCreazione'] == null ? undefined : ((value['dataCreazione']).toISOString()),
        'oppMOL': value['oppMOL'],
        'oppNumAttivitaInAgenda': value['oppNumAttivitaInAgenda'],
        'linkOppSF': value['linkOppSF'],
    };
}
